import { makeStyles, tokens } from "@fluentui/react-components";
import { textClip } from "../utilities/Mixin.styles";
/**
 * Styles for the dialog title with dismiss button.
 *
 * `titleContainer` lays the heading and the dismiss button out on a single row.
 * `dialogTitle` is the underlying Fluent `DialogTitle` (`<h2>`); it is the constrained
 * flex item (`flex: 1 1 auto; minWidth: 0`) and therefore the correct truncation
 * boundary — `textClip("ellipsis")` lives here so long titles truncate with an ellipsis
 * instead of pushing the close button onto a new line. The inner `titleText` span only
 * carries typography (ellipsis on an inline span has no effect).
 */ export const useDialogTitleWithDismissStyles = makeStyles({
    titleContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%"
    },
    dialogTitle: {
        ...textClip("ellipsis"),
        flex: "1 1 auto",
        minWidth: 0
    },
    titleText: {
        fontSize: tokens.fontSizeBase500,
        fontWeight: tokens.fontWeightSemibold,
        color: tokens.colorNeutralForeground1,
        margin: "0",
        padding: "0",
        lineHeight: tokens.lineHeightBase500
    },
    dismissButton: {
        // Use a logical-property margin so spacing flips correctly in RTL locales.
        marginInlineStart: tokens.spacingHorizontalM,
        borderRadius: tokens.borderRadiusMedium,
        flexShrink: 0
    }
});
